import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './assets/fonts/Stag-Medium.otf';
import './index.css';
import {v4 as uuid} from 'uuid';
import axios from 'axios';
import {_sendLog} from './utils/utility'
import TagManager from 'react-gtm-module'

import createAppStore from './store/app-store';
import App from "./App";
import {SET_PAGE_BROKEN} from "./store/system/types";

const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Wraps App in a fresh Redux store
function ReactReduxApp() {
    let gtmID = 'GTM-KWRCJLS';
    const params = (new URL(document.location)).searchParams;
    const tagManagerArgs = {
        gtmId: gtmID
    }
    TagManager.initialize(tagManagerArgs);

    const [store] = useState(createAppStore);
    generateUuid();
    interceptError(store);

    return (
        <Provider store={store}>
            <App/>
        </Provider>
    );
}

function generateUuid() {
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'dev') {
        const sessionId = uuid();
        _sendLog('Claims-Supplier-Portal - generateUuid - Generated UUID: ' + sessionId, 'info')
        axios.interceptors.request.use((request = {}) => {
            if (request?.params?.hasOwnProperty('handlerEnabled') && !request?.params?.handlerEnabled) {
                delete request.params.handlerEnabled;
                return request;
            }
            request.headers['Session-Name'] = sessionId;
            return request;
        });
        axios.interceptors.response.use(null, (error) => {
            return Promise.reject(error);
        });
    }
}

function interceptError(store) {
    axios.interceptors.request.use((request = {}) => {
        return request;
    });
    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if ((error.response?.status === 500
            || error.response?.status === 502
            || error.response?.status === 503
            || error.response?.status === 504
            || error.response?.status === 408 || error.response?.status === 404) && error.config.shouldIntercept !== 'false')
        {
            store.dispatch({
                type: SET_PAGE_BROKEN,
                showPageBroken: true
            });
        }
        return Promise.reject(error);
    });
}

ReactDOM.render(
    (
        <ReactReduxApp/>
    ),
    document.getElementById('root')
);
